import { TABLE_KEYS } from './tableConfigConstants';

const initialPagination = {
  expandedRow: null,
  query: '',
  page: 1,
  pageSize: 100,
  total: 0,
  sortBy: undefined,
  sortDir: undefined,
};

export const tableConfigInitialState = {
  pagination: {
    [TABLE_KEYS.adminJobs]: {
      ...initialPagination,
      sortBy: 'id',
      sortDir: 'desc',
    },
    [TABLE_KEYS.adminUsers]: initialPagination,
    [TABLE_KEYS.adminProperties]: initialPagination,
    [TABLE_KEYS.guestRequestOrders]: initialPagination,
    [TABLE_KEYS.irdOrders]: initialPagination,
  },
  filters: {
    [TABLE_KEYS.adminJobs]: null,
    [TABLE_KEYS.adminUsers]: null,
    [TABLE_KEYS.adminProperties]: null,
    [TABLE_KEYS.guestRequestOrders]: null,
    [TABLE_KEYS.irdOrders]: null,
  },
  expandedRow: {
    [TABLE_KEYS.adminJobs]: {},
    [TABLE_KEYS.adminUsers]: {},
    [TABLE_KEYS.adminProperties]: {},
    [TABLE_KEYS.guestRequestOrders]: {},
    [TABLE_KEYS.irdOrders]: {},
  },
  addExpanded: {
    [TABLE_KEYS.adminUsers]: false,
    [TABLE_KEYS.adminProperties]: false,
    [TABLE_KEYS.guestRequestOrders]: false,
    [TABLE_KEYS.irdOrders]: false,
  },
};

export function buildApiParamsPagination(request) {
  const url = new URL(request.url);
  const params = new URLSearchParams(url.search);

  const page = params.get('page') || '1';
  const pageSize = params.get('pageSize') || '100';
  const query = params.get('query') || undefined;
  const sortBy = params.get('sortBy') || undefined;
  const sortDir = params.get('sortDir') || undefined;

  return {
    page: parseInt(page),
    pageSize: parseInt(pageSize),
    query,
    sortBy,
    sortDir,
  };
}
